import axios from 'axios';

export const getFaqs = async () => {
    try {
        const response = await axios.get('/api/faqs');
        return response.data;
    } catch (error) {
        console.error('Error fetching FAQs:', error);
        throw error;
    }
};
